export const domainMinLength = 1
export const domainMaxLength = 20
